import { Star, Award, Users, Clock, Shield, ThumbsUp } from "lucide-react";

const reasons = [
  { icon: Star, title: "Doświadczenie", description: "Ponad 500 występów dla największych firm w Polsce" },
  { icon: Award, title: "Profesjonalizm", description: "Zawodowi komicy z wieloletnim stażem scenicznym" },
  { icon: Users, title: "Dostosowanie", description: "Program dopasowany do charakteru Twojej firmy" },
  { icon: Clock, title: "Punktualność", description: "Zawsze na czas, zawsze przygotowani" },
  { icon: Shield, title: "Gwarancja", description: "Gwarantujemy zadowolenie lub zwrot pieniędzy" },
  { icon: ThumbsUp, title: "Rekomendacje", description: "Setki pozytywnych opinii od klientów" },
];

export const WhyUs = () => {
  return (
    <section id="why-us" className="py-24 section-darker relative overflow-hidden">
      <div className="absolute inset-0 mesh-gradient opacity-30" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-space-grotesk font-bold text-center mb-4 text-foreground">
          Dlaczego <span className="text-gradient">my?</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Co nas wyróżnia na tle konkurencji?
        </p>
        <div className="grid md:grid-cols-3 gap-4">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div key={reason.title} className="glass rounded-2xl p-6 hover:bg-white/[0.08] hover:border-accent/20 transition-all duration-300 hover:-translate-y-1 group">
                <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent/20 transition-colors">
                  <Icon className="w-6 h-6 text-accent" />
                </div>
                <h3 className="text-lg font-space-grotesk font-bold mb-2 text-foreground">{reason.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
